import * as React from 'react';

import {motion} from 'framer-motion';

import {getUserPrefersReducedMotion} from 'nutshell-core/utils/get-user-prefers-reduced-motion';

type Props = {
    children: React.ReactNode;
    isExpanded: boolean;
    // If false, skips animation on first mount (useful when initial state comes from localStorage)
    animateOnMount?: boolean;
    collapsed?: {
        [key: string]: any;
    };
    expanded?: {
        [key: string]: any;
    };
    transition?: {
        [key: string]: any;
    };
};

const DEFAULT_COLLAPSED = {
    height: 0,
    opacity: 0,
    overflow: 'hidden',
} as const;

const DEFAULT_EXPANDED = {
    height: 'auto',
    opacity: 1,
    overflow: 'visible',
} as const;

const DEFAULT_TRANSITION = {
    duration: 0.2,
    ease: 'easeInOut',
} as const;

// Note: This animation works by hidding instead of unmounting the content when collapsed.
// This ensures that the content is always in the DOM and can be measured immediately,
// which is important for the first few animations to run smoothly.
export function CollapseExpandAnimation(props: Props) {
    const {
        animateOnMount = false,
        collapsed = DEFAULT_COLLAPSED,
        expanded = DEFAULT_EXPANDED,
        transition = DEFAULT_TRANSITION,
    } = props;

    if (getUserPrefersReducedMotion()) {
        return props.isExpanded ? props.children : null;
    }

    return (
        <motion.div
            initial={animateOnMount ? collapsed : false}
            animate={props.isExpanded ? expanded : collapsed}
            transition={transition}
        >
            {props.children}
        </motion.div>
    );
}
